export { default } from "../legacy/bimbel";
